module.exports = __webpack_public_path__ + "static/media/airpodspro.859c1071.webp";